import { useState } from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-switch';

// ---------------------------------------------------------

import styles from './styles.module.scss';
const { container, toggle_label } = styles;

// ---------------------------------------------------------

const Toggle = ({ label, isToggledCallback, checkedOnDefault }) => {
  const [checked, setChecked] = useState(checkedOnDefault || false);

  const handleChange = (isChecked) => {
    setChecked(isChecked);
    isToggledCallback(isChecked);
  };

  return (
    <label htmlFor={`${label}-id`} className={container}>
      <Switch
        onChange={handleChange}
        checked={checked}
        className="react-switch"
        uncheckedIcon={false}
        checkedIcon={false}
        width={36}
        height={20}
        onColor={'#000'}
        id={`${label}-id`}
      />
      <span className={toggle_label}>{label}</span>
    </label>
  );
};

Toggle.propTypes = {
  /**
   * Specifies if the toggle is check on default
   */
  checkedOnDefault: PropTypes.bool,
  /**
   * Callback method that specifies if the toggle is checked
   */
  isToggledCallback: PropTypes.func,
  /**
   * Specifies the label associated to the toggle
   */
  label: PropTypes.string
};

export default Toggle;
